import React, { Component } from "react";
import { FormGroup, FormControl } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "../css/login.css";
import { UserService } from "../Services/UserService";
import { Grid, FormLabel, Divider, Hidden } from "@material-ui/core";
import { messaging, requestToken, messaginIsSupported } from "../Notification/init-fcm";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
        isLoading: false,
        mobile_no: "",
        code: "",
        user: this.props.user
    };
  }

  componentDidMount(){
    this.props.setTitle('');
    const user = localStorage.getItem('user') !== null ? JSON.stringify(localStorage.getItem('user')) : null;
    if(user !== null) {
        this.props.history.push("/");
    } else {
      this.props.setAuthenticating(false);
    }
  }

  validateForm() {
    return this.state.mobile_no.length > 9 && this.state.code.length > 3;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
        let body = { mobile_no : this.state.mobile_no,
                    code : this.state.code
                    };
        console.log(JSON.stringify(body));
        UserService.authenticate(body)
        .then((data) => {
            if ( data.id && data.status === '1' ) {
                // this.props.showSnackBar("Logged in" , 'success');
                this.props.updateUser(data);
                console.log("Logged in");
                console.log(data);
                localStorage.setItem('user', JSON.stringify(data));
                this.props.userHasAuthenticated(true);

                if(messaginIsSupported){
                  messaging.requestPermission()
                  .then( () => {
                      console.log("Have Permission");
                      requestToken(data);
                  })
                  .catch((err) => {
                    console.log("Unable to get permission to notify.", err);
                  });
                }

                this.props.history.push("/");
            } else if(data.status === '0'){
              this.props.showSnackBar("Your account has been deactivated. Contact Admin" , 'error');
              this.setState({ isLoading: false });
            }
        })
        .catch((error) => {
          this.props.showSnackBar("Failed to Login. invalid credentials" , 'error');
            this.setState({ isLoading: false });
        });

        
      } catch (e) {
        alert(e.message);
        this.setState({ isLoading: false });
      }
  }

  render() {
    return (
      <div className="Login" style={{height: '100vh'}}>
      <Grid container direction="row" justify="center" alignItems="center" style={{height: '50vh'}}>
          <Grid item xs={12} lg={6}>
            <img src={process.env.PUBLIC_URL + '/images/logo-Retina.png'} alt="Logo" height={200}/>
          </Grid>
          <Hidden mdDown>
            <Grid item xs={1} lg={1} style={{height: '50vh'}}>
              <Divider orientation="vertical" variant="middle"/>
            </Grid>
          </Hidden>
          <Grid item xs={12} lg={5}>
            <form onSubmit={this.handleSubmit}>
              <FormGroup controlId="mobile_no"  size="lg">
                <FormLabel>Mobile</FormLabel>
                <FormControl
                  autoFocus
                  size="lg"
                  required
                  type="text"
                  value={this.state.mobile_no}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="code"  size="lg">
                <FormLabel>Code</FormLabel>
                <FormControl
                  size="lg"
                  ref="code"
                  value={this.state.code}
                  required
                  onChange={this.handleChange}
                  type="password"
                />
              </FormGroup>
              <LoaderButton
                    block
                    size="lg"
                    disabled={!this.validateForm()}
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Login"
                    loadingText="Logging in…"
                    />
            </form>
          </Grid>
        </Grid>
        {/* <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="mobile_no" bsSize="large">
            <ControlLabel>Mobile</ControlLabel>
            <FormControl
              autoFocus
              required
              type="text"
              value={this.state.mobile_no}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="code" bsSize="large">
            <ControlLabel>Code</ControlLabel>
            <FormControl
              ref="code"
              value={this.state.code}
              required
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <LoaderButton
                block
                bsSize="large"
                disabled={!this.validateForm()}
                type="submit"
                isLoading={this.state.isLoading}
                text="Login"
                loadingText="Logging in…"
                />
        </form> */}
      </div>
    );
  }
}